import { Skeleton } from '../../../Skeleton'

import { REQUEST_PROFILE_TAB_ACTIVITIES_SKELETON_COLLAPSED_PHASES_COUNT } from './RequestProfileTabActivitiesSkeleton.constants'
import { RequestProfileTabActivitiesSkeletonPhase } from './RequestProfileTabActivitiesSkeletonPhase'

import * as styles from './RequestProfileTabActivitiesSkeleton.module.css'

function RequestProfileTabActivitiesSkeleton() {
  return (
    <div className={styles.RequestProfileTabActivitiesSkeleton}>
      <RequestProfileTabActivitiesSkeletonPhase isExpanded />
      {Array.from({
        length: REQUEST_PROFILE_TAB_ACTIVITIES_SKELETON_COLLAPSED_PHASES_COUNT,
      }).map((_, index) => (
        <RequestProfileTabActivitiesSkeletonPhase
          isExpanded={false}
          key={index}
        />
      ))}
      <div className={styles.footer}>
        <Skeleton className={styles.addPhaseSkeleton} />
      </div>
    </div>
  )
}

export default RequestProfileTabActivitiesSkeleton
